<template>
  <div>
    <DataTable :options="options" module="warehouse"/>
  </div>
</template>

<script>

import DataTable from "@/components/parts/general/DataTable"
import options from "@/data/warehouse/kit"

export default {
  name: "Kits",
  head() {
    return {
      title: this.$t('kits'),
    }
  },
  components: {
    DataTable
  },
  data() {
    return {
      options: options
    }
  },
  mounted() {
    this.$store.commit('setEloquentOptions', options)
  }
}
</script>

<style scoped>

</style>
